import { BaseFetch } from "../main-model"
export default class ReportStudentNeedHelpModel extends BaseFetch {
    getReportStudentNeedHelpBy = (data) =>
    this.authFetch({
      url: "report-student-need-help/getReportStudentNeedHelpBy",
      method: "POST",
      body: JSON.stringify(data),
    })
}
